import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { usePayrollBundlePageContext } from 'modules/payroll_bundle/components/PayrollBundle'
import PayrollPageLoading from 'modules/payroll_bundle/components/PayrollPageLoading'
import { usePaymentsPageLoader } from 'modules/payroll_bundle/hooks/usePaymentsPageLoader'
import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'
import { SELECT_DATA } from 'modules/payroll_bundle/lib/constants'
import { usePayrollPayments } from 'modules/payroll_bundle/lib/payrollPaymentsContext'

import PaymentConceptSelectionModal from './PaymentConceptSelectionModal'
import Payments from './Payments'

const PaymentsPage = () => {
  const payrollBundleContext = usePayrollBundlePageContext()
  const { paymentStage, showSelectConceptModal } = usePayrollPayments()
  const { fetching } = usePaymentsPageLoader()
  const { loading, canSeeCompanyPayrollResults } = usePayrollContextlessPolicies()

  if (fetching || loading) {
    return <PayrollPageLoading />
  }

  if (!canSeeCompanyPayrollResults) {
    return null
  }

  return (
    <>
      {paymentStage !== SELECT_DATA && (
        <>
          {showSelectConceptModal && <PaymentConceptSelectionModal />}
          <Box width="full" flexGrow>
            <Payments />
          </Box>
        </>
      )}

      <Outlet context={payrollBundleContext} />
    </>
  )
}

export default observer(PaymentsPage)
